var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button full-100 is-primary",on:{"click":function($event){return _vm.handlePlayOnWeb()}}},[_vm._v(" "+_vm._s(_vm.$t('playGameBtn'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }